let store = {
  namespaced: true,
  state: {
    token: null,
    info: null,
    loggedIn: false
  },
  mutations: {
    LOGIN (state, payload) {
      let { token, info } = payload
      state.token = token
      state.info = info
      state.loggedIn = true
    },
    LOGOUT (state) {
      state.loggedIn = false
      state.token = null
      state.info = null
    }
  },
  getters: {
    isLoginValid (state) {
      if (!state['token']) { return false }
      return new Date(state['info']['exp'] * 1000) > new Date()
    },
    token (state) {
      return state.token
    }
  },
  actions: {
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/auth.js